import { render } from "./BNavbar.vue?vue&type=template&id=421a0da6&scoped=true&ts=true"
import script from "./BNavbar.vue?vue&type=script&lang=ts"
export * from "./BNavbar.vue?vue&type=script&lang=ts"

import "./BNavbar.vue?vue&type=style&index=0&id=421a0da6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421a0da6"]])

export default __exports__